import styled from "styled-components";
import { zIndex } from "../../constants";

export const Form = styled.form`
  position: relative;
  z-index: ${zIndex.mapControl};
  width: 100%;
  height: 50px;
  border-top: 1px solid #EAEAEA;
  border-bottom: 1px solid #EAEAEA;
  box-shadow: 0px 5px 6px rgba(0,0,0,0.05);

  [data-embedded="true"] & {
    border-top: none;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 100%;
  padding: 10px 60px 10px 50px;
  border: none;
  box-sizing: border-box;
  font-family: "Reader";
  font-size: 18px;
  color: var(--color-text-gray);

  &:focus {
    outline: 1px solid var(--color-secondary);
  }

  &::placeholder {
    color: var(--color-text-gray);
  }
`;

export const CancelButton = styled.button`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  background: none;
  border: none;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  fill: var(--color-med-gray);
  cursor: pointer;

  &:hover,
  &:focus {
    fill: var(--color-secondary);
    outline: none;
  }
`;

export const CancelIcon = styled.svg`
  width: 14px;
  height: 14px;
`;

export const Icon = styled.img`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  margin: 0 0 0 20px;
`;
